// src/components/leaderboard/LeaderboardButton.js
//
// "🏆 Leaders" — opens the weekly leaderboard. Sits beside the coin counter
// and shop button (student dashboard, subject pages) and in the teacher's
// students list.
//
// Props: code (class code), myUid, isEducator, label

import React, { useState } from "react";
import { getAuth } from "firebase/auth";
import LeaderboardPopup from "./LeaderboardPopup";
import "./leaderboard.css";

const LeaderboardButton = ({ code, myUid, isEducator = false, label = "Leaders", className = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className={`sbl-lb-open ${className}`} onClick={() => setOpen(true)}>
        <span aria-hidden="true">🏆</span> {label}
      </button>
      {open && (
        <LeaderboardPopup
          code={code}
          myUid={myUid || getAuth().currentUser?.uid}
          isEducator={isEducator}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default LeaderboardButton;
